import { render, staticRenderFns } from "./ChatCreateTaskForm.vue?vue&type=template&id=35f0b808"
import script from "./ChatCreateTaskForm.vue?vue&type=script&lang=js"
export * from "./ChatCreateTaskForm.vue?vue&type=script&lang=js"
import style0 from "./ChatCreateTaskForm.vue?vue&type=style&index=0&id=35f0b808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports